import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Spin } from 'antd'
import MainLayout from '@/layouts/MainLayout'
import PrivateRoute from './PrivateRoute'

// 이 프로젝트는 기록입력 시스템이고 필요한 기능은 저장/수정/조회 3가지뿐이다(루트 CLAUDE.md 참고).
// estimate(고과평가/연봉) 프로젝트에서 넘어온 화면들(평가·연봉산정·연봉협상·Stat&연봉·선수관리·훈련영상·
// 통계·검증·배치/데이터관리)은 라우트와 함께 제거했다.
// 경기 생성/상세/결과 화면도 제거했다 — 경기는 외부에서 등록되고, 이 시스템은 경기 목록에서
// 기록입력·기록조회로 들어가는 동선만 담당한다(대응 백엔드 API도 그 범위로만 구현).

// lazy import — 초기 번들 크기 최소화
const LoginPage            = lazy(() => import('@/features/auth/LoginPage'))
const GameListPage         = lazy(() => import('@/features/games/GameListPage'))
const RecordListPage       = lazy(() => import('@/features/records/RecordListPage'))
const RecordInputPage      = lazy(() => import('@/features/records/RecordInputPage'))
const NotFoundPage         = lazy(() => import('@/features/common/NotFoundPage'))
const UnauthorizedPage     = lazy(() => import('@/features/common/UnauthorizedPage'))

const Loading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 80 }}>
    <Spin size="large" />
  </div>
)

const AppRouter: React.FC = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* 공개 라우트 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/not-available" element={<div style={{ padding: 40 }}>이 도메인에서 사용할 수 없는 기능입니다.</div>} />
        <Route path="/unauthorized"  element={<UnauthorizedPage />} />

        {/* 기록 입력 — 전체화면 모드 (MainLayout Sider/상단 헤더 없이 단독 렌더링), 레벨 4 이하 */}
        <Route
          path="/recorder"
          element={
            <PrivateRoute maxUserLevel={4}>
              <RecordInputPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/recorder/:gameInfoId"
          element={
            <PrivateRoute maxUserLevel={4}>
              <RecordInputPage />
            </PrivateRoute>
          }
        />

        {/* 인증 필요 라우트 */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/games" replace />} />

          {/* 경기 관리 — 모든 인증 사용자 접근 가능 */}
          <Route path="/games" element={<GameListPage />} />

          {/* 기록 조회 */}
          <Route path="/records/:gameInfoId" element={<RecordListPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
)

export default AppRouter
